import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../lib/supabase.js';
import { useAuth } from '../lib/auth.jsx';
import { StatusBar } from '../components/StatusBar.jsx';
import { CampLogo } from '../components/CampLogo.jsx';

export function Login() {
  const { session, loading } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  if (!loading && session) return <Navigate to="/" replace />;

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true);
    setErr('');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setErr(error.message);
    setBusy(false);
  }

  return (
    <div className="phone">
      <StatusBar />
      <section className="screen">
        <div className="login-brand">
          <CampLogo height={42} />
          <h1 className="page" style={{ marginTop: 18 }}>ห้องปกครอง</h1>
          <div className="eyebrow" style={{ marginTop: 4 }}>เข้าสู่ระบบเพื่อใช้งาน</div>
        </div>

        <form onSubmit={onSubmit} style={{ marginTop: 26 }}>
          <label className="f" htmlFor="email">อีเมล</label>
          <input id="email" type="email" autoComplete="username" required
            value={email} onChange={(e) => setEmail(e.target.value)} />

          <label className="f" htmlFor="pw">รหัสผ่าน</label>
          <input id="pw" type="password" autoComplete="current-password" required
            value={password} onChange={(e) => setPassword(e.target.value)} />

          {err && <p className="err" style={{ marginTop: 14 }}>{err}</p>}

          <button className="cta" type="submit" disabled={busy}>
            {busy ? 'กำลังเข้าสู่ระบบ…' : 'เข้าสู่ระบบ'}
          </button>
        </form>
        <p className="note" style={{ marginTop: 16, textAlign: 'center' }}>
          ติดต่อแอดมินหากยังไม่มีบัญชี
        </p>
      </section>
    </div>
  );
}
